import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconAccounting: React.FC<IconProps> = ({
  size = 21,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 21 17"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path d="M1.02083 4.4375C1.02083 2.56779 2.53654 1.05208 4.40625 1.05208L16.5938 1.05208C18.4635 1.05208 19.9792 2.56779 19.9792 4.4375V12.5625C19.9792 14.4322 18.4635 15.9479 16.5938 15.9479L4.40625 15.9479C2.53654 15.9479 1.02083 14.4322 1.02083 12.5625L1.02083 4.4375Z" stroke="currentColor" strokeWidth="1.35417"/>
    <path d="M14.224 8.5C14.224 7.1912 15.285 6.13021 16.5938 6.13021L19.9792 6.13021V10.8698H16.5938C15.285 10.8698 14.224 9.8088 14.224 8.5Z" stroke="currentColor" strokeWidth="1.35417"/>
    <path d="M4.40625 4.4375L8.97656 4.4375" stroke="currentColor" strokeWidth="1.35417" strokeLinecap="round"/>
  </svg>
);

export default IconAccounting;
